module.exports = __webpack_public_path__ + "d07b5e97d145914035acdc3818c4e0ac.png";